import React from "react";

import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import NumberValue from "../../components/NumberValue";



const TabUsers: React.FC = () => {
  const stats = useSelector((state: RootState) => state.stats);

  return (
    <Stack direction="column" spacing={4}>
      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Users</TableCell>
              <TableCell align="right">Total</TableCell>
              <TableCell align="right">Male</TableCell>
              <TableCell align="right">Female</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">Registered</TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.total}/></TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.totalMale}/></TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.totalFemale}/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">Active</TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.active}/></TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.activeMale}/></TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.activeFemale}/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">Online</TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.online}/></TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.onlineMale}/></TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.onlineFemale}/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">Popular</TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.popularUsers}/></TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.popularMaleUsers}/></TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.popularFemaleUsers}/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">Deleted</TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.deleted}/></TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.deletedMale}/></TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.deletedFemale}/></TableCell>
            </TableRow>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">Disabled</TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.disabled}/></TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.disabledMale}/></TableCell>
              <TableCell align="right"><NumberValue number={stats.users?.disabledFemale}/></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Photos</TableCell>
              <TableCell align="right">Count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">Total</TableCell>
              <TableCell align="right"><NumberValue number={stats.photos?.total}/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">Active</TableCell>
              <TableCell align="right"><NumberValue number={stats.photos?.active}/></TableCell>
            </TableRow>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">Deleted</TableCell>
              <TableCell align="right"><NumberValue number={stats.photos?.deleted}/></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default TabUsers;